// extracted by mini-css-extract-plugin
module.exports = {"MainLayout":"MainLayout_MainLayout__25Pbq"};